import { Html } from "@labs/schema";
import clsx from "clsx";
import getVideoId from "get-video-id";
import { isElement } from "hast-util-is-element";
import { selectAll } from "hast-util-select";
import React from "react";
import { listBullet } from "../../../utils/list-bullets";
import { FadeUp } from "../FadeUp";
export var embeddedVideos = function() {
    return function(tree) {
        selectAll("p", tree).forEach(function(node) {
            if (node.children.length === 1 && isElement(node.children[0]) && node.children[0].tagName === "a") {
                var _node_children__properties;
                var url = (_node_children__properties = node.children[0].properties) === null || _node_children__properties === void 0 ? void 0 : _node_children__properties.href;
                var videoId = getVideoId(url || "");
                if (videoId.id && videoId.service === "youtube") {
                    node.children = [
                        {
                            type: "element",
                            tagName: "div",
                            properties: {
                                className: "w-full relative aspect-w-16 aspect-h-9"
                            },
                            children: [
                                {
                                    type: "element",
                                    tagName: "iframe",
                                    properties: {
                                        src: "https://www.youtube-nocookie.com/embed/".concat(videoId.id)
                                    },
                                    children: []
                                }
                            ]
                        }
                    ];
                }
            }
        });
    };
};
export default function Prose(param) {
    var content = param.content, columnLists = param.columnLists, headingColor = param.headingColor, className = param.className;
    var processed = content.replaceAll(/<\/blockquote>\s*<p>-(.*?)<\/p>/g, "<cite>$1</cite></blockquote>").replaceAll('href="https://www.amazeelabs.com/', 'href="/');
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 30
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("prose container-content-wrapper hover:prose-a:text-black mt-5 md:mt-8 prose-headings:text-turquoise-500", className)
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: processed,
        plugins: [
            listBullet(columnLists),
            embeddedVideos
        ],
        classNames: {
            "ul li a": "transition",
            "h1,h2,h3,h4,h5,h6": headingColor === "purple" ? "text-purple-500" : "text-turquoise-500",
            "h1,h2": "lg:mr-[25%]"
        }
    }))));
}
